import { maxBreakpoints, minBreakpoints, pulse, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const card = css`
  height: 100%;
  position: relative;
`;

export const copy = css`
  display: flex;
  flex-direction: column;
  margin-top: ${pxToRem(20)};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      flex-direction: row;
      justify-content: space-between;
    `,
  )};
`;

export const mainSection = css`
  width: 100%;

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      width: 60%;
    `,
  )};
`;

export const labelMargin = css`
  margin-bottom: ${spacing.sm}px;
`;

export const imagePlaceholder = css`
  width: 100%;
  padding-top: 100%;
  border-radius: ${pxToRem(10)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-radius: ${pxToRem(20)};
    `,
  )};

  ${pulse}
`;

export const mobileImageCropEven = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      border-radius: 0 ${pxToRem(10)} ${pxToRem(10)} 0;
    `,
  )};
`;

export const mobileImageCropOdd = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      &:nth-child(odd) {
        border-radius: ${pxToRem(10)} 0 0 ${pxToRem(10)};
      }
    `,
  )}
`;

export const line = css`
  width: 100%;
  height: ${pxToRem(20)};
  margin: 0 0 ${spacing.xs}px 0;
  border-radius: ${pxToRem(6)};
  ${pulse}
`;
